import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Alert, Button} from 'react-bootstrap';
import {onLogout} from '../actions/AccountActions';
import {connect} from 'react-redux';

@connect(state => ({error: state.auth.error}), {onLogout})
export default class Logout extends Component {
    static propTypes = {
        onLogout: PropTypes.func,
        error: PropTypes.object
    };

    componentDidMount() {
        this.props.onLogout();
    }

    render() {
        return (
            <div className="page">
                <div className="page_contents">
                    <div className="card">
                        <h1>{'Logout'}</h1>
                        <p>{this.props.error ? <Alert bsStyle="danger">{'Logout failed.'}</Alert> : 'You have been successfully logged out.'}</p>
                        <Button href="/login" bsStyle="primary" style={{width: 150}}>{'LOGIN'}</Button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Logout.js